import { useAppDispatch, useAppSelector } from "@/app/hooks";
import exploreIcon from '@/assets/explore_icon.png';
import selectedExploreIcon from '@/assets/selected_explore_icon.png';
import { setSaveItem, setSaveMode } from "@/components/SavePage/saveSlice";
import { currentSelectedParcelShape, currentSelectedSearchResult, selectedParcelShapeError } from "@/components/Search/searchSlice";
import { createSaveItem } from "@/lib/saved-items";
import { Button, Group, Text } from "@mantine/core";
import { setSelectedMenuItem } from "../menuSlice";
import MenuTab from "./MenuTab";

interface ExploreMenuItemProps {
    children?: React.ReactNode;
}

const ExploreMenuItem: React.FC<ExploreMenuItemProps> = ({ children }) => {
    const currentSearchResult = useAppSelector(currentSelectedSearchResult);
    const selectedParcelShape = useAppSelector(currentSelectedParcelShape);
    const shapeError = useAppSelector(selectedParcelShapeError);
    const dispatch = useAppDispatch();
    const canSave = Boolean(currentSearchResult && selectedParcelShape && currentSearchResult.type !== 'geocode');

    const onSaveClickHandler = () => {
        if (!canSave) return;
        const attributes = currentSearchResult?.attributes;
        const details = [
            attributes?.apn && `APN: ${attributes.apn}`,
            attributes?.names && `Owner: ${attributes.names}`,
            attributes?.s_addr_d && `Address: ${attributes.s_addr_d}, ${attributes.s_city} ${attributes.s_st} ${attributes.s_zip}`,
        ].filter((detail): detail is string => Boolean(detail));
        dispatch(setSaveMode('new'));
        dispatch(setSaveItem(createSaveItem({ itemType: 'parcel', shape: selectedParcelShape, itemDetails: details, color: 'cyan', size: 'small' })));
        dispatch(setSelectedMenuItem('closed'));
    }

    return (
        <MenuTab
            item='explore'
            label='Explore'
            icon={exploreIcon}
            selectedIcon={selectedExploreIcon}
            title={
                <Group align='center' justify='space-between'>
                    <Text size='sm'>Parcel Details</Text>
                    <Button disabled={!canSave} variant='transparent' size='xs' color='pq-red' onClick={onSaveClickHandler}>Save Item</Button>
                </Group>
            }>
            {shapeError && <Text role="alert" c="red" size="sm" m="sm">{shapeError}</Text>}
            {children}
        </MenuTab>
    );
}

export default ExploreMenuItem;
